module.exports = __webpack_public_path__ + "img/email.72402cf0.png";